import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { SimpleFundChartModule } from 'ChartApp/ts/features/simple-fund-chart/simple-fund-chart.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { YieldCurveModule } from 'TargetRatesApp/features/yield-curve-component/yield-curve.module';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { IntradaysRatesComponent } from 'TargetRatesApp/features/intradays-rates-component/intradays-rates.component';
import { KeyRatesComponent } from 'TargetRatesApp/features/key-rates-component/key-rates.component';
import { YieldCurveComponent } from 'TargetRatesApp/features/yield-curve-component/yield-curve.component';
import { getLogger } from 'NewAngular/state/logger';
import { rootReducer } from 'TargetRatesApp/apps/target-rates-app/target-rates.store';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngrx/store";
export class AppModule {
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [IntradaysRatesComponent, KeyRatesComponent, YieldCurveComponent, TopBarNavComponent, SideMenuComponent] });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        NavigationModule,
        SimpleFundChartModule,
        FormsModule,
        YieldCurveModule,
        RouterModule.forRoot([{ path: 'yield_curve', component: YieldCurveComponent }]),
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() })] });
